import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><g><path style={{
      fill: "#C8414B"
    }} d="M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v98.483h512v-98.483   C512,105.443,494.833,88.276,473.655,88.276z" /><path style={{
      fill: "#C8414B"
    }} d="M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345   v-98.483H0V385.379z" /></g><rect y={225.1} style={{
    fill: "#F5F5F5"
  }} width={512} height={61.793} /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };